import React, { useState } from 'react';
import * as Styles from './HowToSetupStep.styles';
import {
  Button,
  IconArrow,
  CopySnippet,
  IconChevron,
  Checkbox,
} from 'gatorcomponents';
import PropTypes from 'prop-types';
import { PROVIDERS_LINKS } from '../../useDnsModal.types';
import { useResize } from '@/hooks/useResize';

export const HowToSetupStep = ({
  selectedManualDns,
  onClickBack,
  onHowToSetupClick,
  serverLabel,
  continueLabel,
  backLabel,
  originalDnsLabel,
  newDnsLabel,
  domainHasConfiguredLabel,
  configureDomainText,
  configureDomainButton,
  cloudflareDns = {
    ns1: '',
    ns2: '',
  },
  originalDns = {
    ns1: '',
    ns2: '',
  },
  subtitle,
  helpLink,
}) => {
  const [domainHasConfigured, setDomainHasConfigured] = useState(false);

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;

  const isOther = ['Outros', 'Otros'].includes(selectedManualDns);

  const handleGoNext = () => {
    onHowToSetupClick && onHowToSetupClick();
  };

  const handleSetDomainConfigured = () => {
    setDomainHasConfigured(!domainHasConfigured);
  };

  const handleGoBack = () => {
    onClickBack && onClickBack();
  };

  const handleOpenLink = ({ label }) => {
    const url = PROVIDERS_LINKS.find(provider => provider.name === label).page;
    window.open(url, '_blank');
  };

  return (
    <Styles.Wrapper data-testid="HowToSetupStep">
      <Styles.ContentRow>
        <Styles.ContentColumn>
          <Styles.Subtitle>
            <Styles.Circle displayOnMobile>2</Styles.Circle>
            {subtitle}
          </Styles.Subtitle>

          <Styles.DnsContentRow>
            {originalDns.ns1 && originalDns.ns2 && (
            <Styles.DnsContentColumn>
              {originalDnsLabel}
              <Styles.OriginalDnsContainer>
                <Styles.OriginalDnsLabel>
                  {serverLabel(0)}
                  <Styles.OriginalDnsText>
                    {originalDns.ns1}
                  </Styles.OriginalDnsText>
                </Styles.OriginalDnsLabel>
                <Styles.OriginalDnsLabel>
                  {serverLabel(1)}
                  <Styles.OriginalDnsText>
                    {originalDns.ns2}
                  </Styles.OriginalDnsText>
                </Styles.OriginalDnsLabel>
              </Styles.OriginalDnsContainer>
            </Styles.DnsContentColumn>
            )}

            <Styles.ChevronWrapper>
              <IconChevron
                direction={mobile ? 'bottom' : 'right'}
                size="xl"
                color="primaryMedium"
              />
            </Styles.ChevronWrapper>

            <Styles.DnsContentColumn>
              {newDnsLabel}
              <CopySnippet
                withBorder
                label={serverLabel(0)}
                content={cloudflareDns && cloudflareDns.ns1}
              />
              <CopySnippet
                withBorder
                label={serverLabel(1)}
                content={cloudflareDns && cloudflareDns.ns2}
              />
            </Styles.DnsContentColumn>
          </Styles.DnsContentRow>

          {!isOther && (
          <>
            <Styles.Subtitle>
              {configureDomainText}
            </Styles.Subtitle>

            <Button
              label={configureDomainButton}
              onClick={() => handleOpenLink({ label: selectedManualDns })}
              variant="secondary"
              size="large"
            />
          </>
          )}

          <Styles.HelpCenterWrapper>
            {helpLink}
          </Styles.HelpCenterWrapper>
        </Styles.ContentColumn>
      </Styles.ContentRow>

      <Styles.CheckboxLabel onClick={handleSetDomainConfigured} data-testid="domainConfigured">
        <Checkbox checked={domainHasConfigured} />
        <Styles.Subtitle>{domainHasConfiguredLabel}</Styles.Subtitle>
      </Styles.CheckboxLabel>

      <Styles.ActionsRow>
        <Button
          onClick={handleGoBack}
          size="large"
          label={backLabel}
          variant="tertiary"
          testId="goBackButton"
        />
        <Button
          size="large"
          label={continueLabel}
          onClick={handleGoNext}
          disabled={!domainHasConfigured}
          testId="goToNextButton"
          iconRight={<IconArrow direction="right" />}
        />
      </Styles.ActionsRow>
    </Styles.Wrapper>
  );
};

HowToSetupStep.propTypes = {
  selectedManualDns: PropTypes.string,
  onClickBack: PropTypes.func,
  onHowToSetupClick: PropTypes.func,
  serverLabel: PropTypes.func,
  continueLabel: PropTypes.string,
  backLabel: PropTypes.string,
  domainHasConfiguredLabel: PropTypes.string,
  originalDnsLabel: PropTypes.string,
  newDnsLabel: PropTypes.string,
  configureDomainText: PropTypes.string,
  configureDomainButton: PropTypes.string,
  cloudflareDns: PropTypes.shape({
    ns1: PropTypes.string,
    ns2: PropTypes.string,
  }),
  originalDns: PropTypes.shape({
    ns1: PropTypes.string,
    ns2: PropTypes.string,
  }),
  subtitle: PropTypes.string,
  helpLink: PropTypes.node,
};

export default HowToSetupStep;
